import { render, staticRenderFns } from "./ProfileDashboard.vue?vue&type=template&id=f3ac9d14"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProfileDashboard.vue?vue&type=style&index=0&id=f3ac9d14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports